import { render, staticRenderFns } from "./money.vue?vue&type=template&id=0f503598&scoped=true"
import script from "./money.vue?vue&type=script&lang=js"
export * from "./money.vue?vue&type=script&lang=js"
import style0 from "./money.vue?vue&type=style&index=0&id=0f503598&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f503598",
  null
  
)

export default component.exports